import UAParser from 'ua-parser-js';

export const ALLOWED_BROWSERS = {
  desktop: [
    { os: '', browser: 'Firefox', minVersion: 76 },
    { os: '', browser: 'Safari', minVersion: 13 },
    { os: '', browser: 'Edge', minVersion: 18 },
    { os: '', browser: 'Chrome', minVersion: 83 },
  ],
  mobile: [
    { os: 'Android', browser: 'Chrome', minVersion: 0 },
    { os: 'iOS', browser: 'Safari', minVersion: 0 },
    { os: 'Mac OS', browser: 'Safari', minVersion: 0 },
  ],
};

export const isBrowser = () => typeof window !== 'undefined';
export const UA = new UAParser();
const { name, version } = UA.getBrowser();
export const { device, os } = UA.getResult();
const getUA = () =>
  isBrowser() ? navigator.userAgent || navigator.vendor : '';

export const isTouchDevice = () =>
  (isBrowser() && 'ontouchstart' in window) ||
  'ontouchstart' in document.documentElement ||
  navigator.maxTouchPoints > 0 ||
  navigator.msMaxTouchPoints > 0;
export const isIOS = () => os.name === 'iOS';
export const isAndroid = () => os.name === 'Android';
export const isMobile = () => device.type === 'mobile';
export const isTablet = () => device.type === 'tablet' || isRecentIPadSafari();
export const isDesktop = () => !isMobile() && !isTablet();
// As of Safari iOS 13, iPads return UA strings identical to Mac OS, instead of iOS
export const isRecentIPadSafari = () =>
  isTouchDevice() && isSafari() && !isIOS();
export const isRecentOS = () =>
  (isAndroid() && parseFloat(os.version) >= 9) ||
  (isIOS() && parseFloat(os.version) >= 13) ||
  isRecentIPadSafari();

// Browsers
export const isSafari = () =>
  isBrowser() && name.toLowerCase().indexOf('safari') > -1;
export const isOpera = () =>
  isBrowser() && name.toLowerCase().indexOf('opera') > -1;
export const isFirefox = () =>
  isBrowser() && name.toLowerCase().indexOf('firefox') > -1;
export const isIE = () => isBrowser() && name.indexOf('IE') > -1;
export const isEdge = () =>
  isBrowser() && (name.indexOf('Edge') > -1 || /.*EdgA*/.test(getUA()));
export const isChrome = () => isBrowser() && name.indexOf('Chrome') > -1;
export const isFacebook = () =>
  isBrowser() && (getUA().indexOf('FBAN') > -1 || getUA().indexOf('FBAV') > -1);
export const isInstagram = () =>
  isBrowser() && getUA().indexOf('Instagram') > -1;
export const isTwitter = () => isBrowser() && getUA().indexOf('Twitter') > -1;

export const isSocialBrowser = () =>
  isFacebook() || isInstagram() || isTwitter();

export const isStorybook = () =>
  isBrowser() &&
  window.location.pathname === '/iframe.html' &&
  window.location.port === '6006';

export const isSupportedBrowser = () => {
  let isSupported = false;
  let fromSocial = false;
  let needsUpgrade = false;

  if (!isBrowser() || !UA) {
    return { isSupported, fromSocial, needsUpgrade };
  }

  const allowedBrowsers = ALLOWED_BROWSERS[isDesktop() ? 'desktop' : 'mobile'];

  const supportedBrowser = allowedBrowsers.find(
    item => name.match(item.browser) && (item.os ? item.os === os.name : true)
  );

  if (supportedBrowser) {
    isSupported = true;
  }

  if (isSocialBrowser()) {
    fromSocial = true;
  }

  if (supportedBrowser && parseFloat(version) < supportedBrowser.minVersion) {
    needsUpgrade = true;
  }

  return { isSupported, fromSocial, needsUpgrade };
};

export const hasWebGl = () => {
  try {
    return Boolean(isBrowser() && window.WebGLRenderingContext);
  } catch (e) {
    return null;
  }
};

export const isLandscape = () =>
  isBrowser() &&
  (isDesktop()
    ? window.innerWidth > window.innerHeight
    : Math.abs(parseInt(`${window.orientation}`)) === 90);
